module.exports = __webpack_public_path__ + "static/media/03-1-galeria-02-gucci-mobile@2x.a6bb484e.jpg";